function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgBurn(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M10.17 24.958a8.34 8.34 0 001.347-.244c4.246-1.138 7.062-5.578 6.382-9.542-.103-.598-.24-1.19-.565-1.816-.063.273-.108.465-.15.657a6.322 6.322 0 01-.867 2.088 3.795 3.795 0 01-1.3 1.245c-.22.126-.45.296-.711.109-.276-.197-.213-.463-.119-.728.07-.193.131-.388.197-.582.46-1.376.516-2.779.272-4.196-.417-2.419-1.509-4.532-3.104-6.406-1.094-1.285-2.357-2.375-3.935-3.07-.395-.176-.808-.313-1.21-.473 1.575 1.928 2.506 4.612 2.046 7.027-.22 1.152-.813 2.146-1.52 3.077-.233.306-.42.381-.644.3-.22-.08-.267-.23-.222-.649.1-.946.065-1.887-.184-2.81-.089-.328-.223-.644-.335-.966-.131 1.059-.52 1.992-1.1 2.851-.364.538-.767 1.051-1.145 1.581-.45.632-.95 1.24-1.333 1.91-1.376 2.42-1.29 4.84.268 7.138 1.671 2.467 4.879 3.8 7.932 3.5z",
    stroke: props.fillSecondary,
    strokeWidth: 1.28,
    strokeLinecap: "round"
  }));
}

export default SvgBurn;